import { Transition } from "../../../core/flows/Transition";
import { CheckoutContext } from "../../CheckoutPage/Context/CheckoutContext";
import { PassengerDetailsContext } from "../../CheckoutPage/PassengerDetailsFlow/Context/PassengerDetailsContext";
import { PaymentContext } from "../../CheckoutPage/Payment/Context/PaymentContext";
import { SeatingMapContext } from "../../CheckoutPage/SeatingMap/Context/SeatingMapContext";
import { VoucherContext } from "../../CheckoutPage/Voucher/Context/VoucherContext";
import { SelectOfferContext } from "../../TrainOfferPage/SelectOfferFlow/Context/SelectOfferContext";
import { TicketOptionContext } from "../../TrainOfferPage/TicketOptionFlow/Context/TicketOptionContext";

export class MainBookingTicketOptionTransition extends Transition {
    constructor(entryStep: string, exitSteps: string[]) {
        super(entryStep, exitSteps);
    }

    onExecute(): string[] {
        
        const context = this.getCtx<TicketOptionContext>("ticketOptionContext", this.entryStep)!;
        if (context.nextTo.includes("SelectOfferFlow") && context.nextTo.includes("TicketOptionFlow")) {

            const selectOfferContext = new SelectOfferContext()
            this.setCtx<SelectOfferContext>("SelectOfferContext", selectOfferContext, this.entryStep)

            const ticketOptionContext = new TicketOptionContext()
            this.setCtx<TicketOptionContext>("ticketOptionContext", ticketOptionContext, this.entryStep);

            context.routeTo = context.nextTo;
            context.nextTo = [];
        }
        else {
            let ticketOptionContext = this.getCtx<TicketOptionContext>("ticketOptionContext")!;            
            const isAnonymous = ticketOptionContext?.trainOfferRequest?.isAnonymous || false            

            const checkoutMapContext = new CheckoutContext(isAnonymous)
            this.setCtx<CheckoutContext>("checkoutContext", checkoutMapContext, this.entryStep)
            
            context.routeTo = ["CheckoutFlow"]
        }

        if (!context) {
            console.log("[Transition] No choice data available, using default exits");
            return this.exitSteps;
        }

        if (!(context.routeTo ?? []).every(step => this.exitSteps.includes(step))) {
            console.log(`[Transition] Invalid choice: ${context.routeTo}`);
            return [];
        }

        return [...(context?.routeTo ?? [])]
    }

}